export default (that, disabled = false) => [
  {
    field: 'seq',
    title: that.$l('table_label_exrcution_seqno') || '执行顺序',
    width: 100,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    visible: !disabled,
    width: 40,
    headerAlign: 'center',
    align: 'center',
    slots: {
      default: 'drag',
    },
    titleHelp: {
      message:
        that.$l('table_header_help_drag') || '按住后拖拽，可调整列表顺序！',
    },
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('table_label_process_name') || '工序名称',
    field: 'processesName',
    minWidth: 200,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_process_remarks') || '工序备注',
    field: 'processesDesc',
    minWidth: 300,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'modifyByName',
    align: 'center',
    width: 100,
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'modifyTime',
    align: 'center',
    width: 170,
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
